/**
 * Belirtilen süre için bir çerez ayarlar.
 * @param {string} name - Çerezin adı
 * @param {string} value - Çerezin değeri
 * @param {number} minutes - Çerezin geçerlilik süresi (dakika cinsinden)
 */
export function setCookie(name, value, minutes) {
  const expires = minutes
    ? `; expires=${new Date(Date.now() + minutes * 60 * 1000).toUTCString()}`
    : '';
  document.cookie = `${name}=${value}${expires}; path=/`;
}

/**
 * Belirtilen gün sayısı için bir çerez ayarlar.
 * @param {string} name - Çerezin adı
 * @param {string} value - Çerezin değeri
 * @param {number} days - Çerezin geçerlilik süresi (gün cinsinden)
 */
export function setCookieInDays(name, value, days) {
  setCookie(name, value, days * 24 * 60);
}

/**
 * Belirtilen adla bir çerezi alır.
 * @param {string} name - Çerezin adı
 * @returns {string} Çerezin değeri veya boş string
 */
export function getCookie(name) {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find(row => row.startsWith(name + '='));
  return cookie ? cookie.split('=')[1] : '';
}